import React, { useState, useEffect } from "react";
import { Select, Spin } from "antd";
import AllSelectionsTable from "./AllSelectionsTable";
import { FilledButton } from "../../commonComponents";
import { setNavItem} from "../../../utils/localStorage";
import { getToken,getAccountId } from "../../../utils/localStorage";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  getAllSelections,
  getPreviousSelections,
  getAllSelectionsForPublic,
} from "../../../utils/service";
import "./AllSelections.scss";

const { Option } = Select;

const AllSelections = () => {
  const [roundValue, setRoundValue] = useState(0);
  const [roundValues, setRoundValues] = useState();
  const [selectionData, setSelectionsData] = useState();
  const [breakDownData, setBreakDownData] = useState();
  const [showTeam, setShowTeam] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const title = searchParams.get("title"); // G
  const data = { id: id, title: title };
  const userToken = getToken();
  const playerId = getAccountId();
  const gameId = location?.state?.data ? location?.state?.data : data;

  const handleRoundChange = (value) => {
    setBreakDownData(
      selectionData?.entries_breakdown[value]?.team_entries[0]?.teams.slice(
        0,
        5
      )
    );
    setRoundValue(value);
  };
  const handleAllSelectionResponse = async () => {
    if (userToken) {
      let response;
      if (gameId?.previousSelection) {
        response = await getPreviousSelections(gameId.id,userToken,playerId);
      } else {
        response = await getAllSelections(gameId.id,userToken,playerId);
      }
      if (response?.data) {
        setSelectionsData(response);
        const roundArray = response?.entries_breakdown?.map((item, index) => {
          return {
            value: index,
            label: `Round ${index + 1}`,
          };
        });
        setRoundValues(roundArray);
        if (gameId?.previousSelection) {
          if (gameId.round) {
            setBreakDownData(
              response?.entries_breakdown[
                gameId.round - 2
              ]?.team_entries[0]?.teams.slice(0, 5)
            );
            setRoundValue(gameId.round - 2);
          } else {
            setBreakDownData(
              response?.entries_breakdown[
                roundValue
              ]?.team_entries[0]?.teams.slice(0, 5)
            );
          }
        } else {
          // Passed round not in the loaded data: fall back to the default round.
          if (gameId.round && response?.entries_breakdown?.[gameId.round - 1]) {
            setBreakDownData(
              response?.entries_breakdown[
                gameId.round - 1
              ]?.team_entries[0]?.teams.slice(0, 5)
            );
            setRoundValue(gameId.round - 1);
          } else {
            setBreakDownData(
              response?.entries_breakdown[
                roundValue
              ]?.team_entries[0]?.teams.slice(0, 5)
            );
          }
        }
      }
      if (!response?.data) {
        let response;
        response = await getAllSelectionsForPublic(gameId.id,userToken,playerId);
        if (response?.data) {
          setSelectionsData(response?.data);
          const roundArray = response?.data?.entries_breakdown?.map(
            (item, index) => {
              return {
                value: index,
                label: `Round ${index + 1}`,
              };
            }
          );
          setRoundValues(roundArray);
          setBreakDownData(
            response?.data?.entries_breakdown[
              roundValue
            ]?.team_entries[0]?.teams.slice(0, 5)
          );
        }
      }
    } else {
      let response;
      response = await getAllSelectionsForPublic(gameId.id,userToken,playerId);
      if (response?.data) {
        setSelectionsData(response?.data);
        const roundArray = response?.data?.entries_breakdown?.map(
          (item, index) => {
            return {
              value: index,
              label: `Round ${index + 1}`,
            };
          }
        );
        setRoundValues(roundArray);
        setBreakDownData(
          response?.data?.entries_breakdown[
            roundValue
          ]?.team_entries[0]?.teams.slice(0, 5)
        );
      }
    }
  };

  const handleGameNavigation = () => {
    setNavItem(1);
    navigate("/game");
  };
  useEffect(() => {
    handleAllSelectionResponse(gameId);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="all-selections">
      <div className="all-selections-title font-cairo-extrabold">
        Game Stats
      </div>
      <div className="all-selections-main">
        <div className="all-selections-main-top">
          <div className="all-selections-main-title font-cairo-extrabold">
            {gameId?.title}
          </div>
          <div className="all-selections-main-top-dropdown">
            <Select
              value={roundValues?.length ? roundValue : "—"}
              onChange={handleRoundChange}
              className="all-selections-dropdown-filter"
              popupClassName="all-selections-dropdown-filter-popupmenu"
            >
              {roundValues?.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="all-selections-main-tables">
          <div className="all-selections-tables-percents">
            <div className="all-selections-tables-percents-title font-cairo-medium">
              Percentage Of Entries Remaining
            </div>
            <div className="all-selections-tables-percents-trophy">
              <div className="all-selections-tables-percents-trophy-numbers font-cairo-bold">
                {typeof selectionData?.entries_breakdown?.[roundValue]
                  ?.percentage === "number"
                  ? `${selectionData.entries_breakdown[
                      roundValue
                    ].percentage.toFixed()}%`
                  : "—"}
              </div>
            </div>
          </div>
          <div className="all-selections-tables-breakdown-title font-cairo-medium">
            Entries Breakdown by Teams
          </div>
          <div className="matches-container all-selections-tables-down">
            {selectionData?.entries_breakdown?.[roundValue]?.team_entries?.[0]?.teams?.map(
              (match, index) => {

                const total = match.count + match.opponent_count;
                const leftPercent = (match.count / total) * 100;

                return (
                  <div className="match-card" key={index}>

                    {/* Teams */}
                    <div className="match-header">

                      <div className="team-left">
                        <span>{match.name}</span>
                        <img src={match.image} alt={match.name} />
                      </div>

                      <div className="score">
                        {match.count} : {match.opponent_count}
                      </div>

                      <div className="team-right">
                        <img src={match.opponent_image} alt={match.opponent_name} />
                        <span>{match.opponent_name}</span>
                      </div>

                    </div>

                    <hr className="teams-line"></hr>

                    <div className="picks-row">
                      <div className="left">{match.count}</div>
                      <div className="center">PLAYERS PICKS</div>
                      <div className="right">{match.opponent_count}</div>
                    </div>

                    {/* Progress bar */}
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${leftPercent}%` }}
                      />
                    </div>

                    <div className="spread-row">
                      <div className="left">{match.percentage}%</div>
                      <div className="center">TOTAL SPREAD</div>
                      <div className="right">{match.opponent_percentage}%</div>
                    </div>

                  </div>
                );
              }
            )}
          </div>
          <div className="all-selections-tables-down">
            {/* <div className="all-selections-tables-distribution">
              <div className="all-selections-tables-breakdown-title font-cairo-medium">
                Entries Distribution by Teams
              </div>
              <div className="all-selections-tables-distribution-cont background-blur">
                {breakDownData ? (
                  <>
                    {breakDownData.slice(0, 5).map((item, index) => {
                      return (
                        <div
                          key={index + 1}
                          className={`all-selections-tables-distribution-divs ${
                            item.percentage < 20
                              ? "size5"
                              : item.percentage < 40
                              ? "size4all-selections-tables-distribution-divs"
                              : item.percentage < 60
                              ? "size3"
                              : item.percentage < 80
                              ? "size2"
                              : item.percentage < 100
                              ? "size5"
                              : null
                          } div${index + 1}`}
                          onMouseEnter={() => setShowTeam(index)}
                          onMouseLeave={() => setShowTeam(null)}
                        >
                          <img
                            alt="League Icon"
                            className="all-selections-tables-distribution-divs-icon"
                            src={item.image}
                          />
                          <div className="font-cairo-bold mobile-percentage">
                            {item.percentage.toFixed(1)}%
                          </div>

                          {showTeam == index && (
                            <div className="all-selections-tables-distribution-showteam">
                              <img
                                alt="League Icon"
                                className="all-selections-tables-distribution-showteam-icon"
                                src={item.image}
                              />
                              <div className="font-cairo-bold">{item.name}</div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="all-selections-tables-distribution-cont-loading">
                    <Spin className="probability-loading-spinner" />
                  </div>
                )}
              </div>
            </div> */}
          </div>
        </div>
        <div className="all-selections-tables-breakdown-title font-cairo-medium">
          Entries by Participants
        </div>
        {selectionData?.data ? (
          <AllSelectionsTable
            tableData={selectionData.data}
            roundCount={selectionData.rounds_count}
          />
        ) : (
          <div className="all-selections-tables-distribution-cont-loading">
            <Spin className="probability-loading-spinner" />
          </div>
        )}
        <div className="all-selections-button">
          <FilledButton
            name={"Join a Game"}
            btnClass="primary-background home-buttons-button"
            type={3}
            functionCall={handleGameNavigation}
          />
        </div>
      </div>
    </div>
  );
};

export default AllSelections;
